module.exports = __webpack_public_path__ + "assets/4874ca49d98e77b6db1bb9a3a81aeaff.png";